import React from 'react';
import { 
    SignupPasswordSection, 
    PasswordBlock, 
    PasswordInputBlock, 
    ConfirmPasswordBlock, 
    InputElementTitle, 
    InputStyle, 
    DeleteButton, 
    DeleteIcon, 
    ErrorBlock, 
    ErrorIcon, 
    ErrorMessage 
} from './style'
import warningIcon from 'images/warning.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-18x18.png';

const SignupPasswordScene = ({
    handleChangePassword, 
    password, 
    passwordError, 
    handleChangeConfirmPassword, 
    confirmPassword, 
    confirmPasswordError, 
    setPassword, 
    setConfirmPassword
}) => {
    const passwordErrorClassName = passwordError ? 'error_active' : null;
    const confirmPasswordErrorClassName = confirmPasswordError ? 'error_active' : null;
    return( 
    <SignupPasswordSection>
        <PasswordBlock>
            <InputElementTitle>비밀번호 입력</InputElementTitle>
            <PasswordInputBlock>
                <InputStyle type='password' className={passwordErrorClassName} onChange={handleChangePassword} value={password} placeholder='영문, 숫자 포함 8자 이상'/>
                {password.length >= 2 ? (
                    <DeleteButton onClick={() => setPassword('')}>
                        <DeleteIcon src={cancelIcon} />
                    </DeleteButton>
                ) : null}
            </PasswordInputBlock>
            {passwordError ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon}/>
                    <ErrorMessage>{passwordError}</ErrorMessage>
                </ErrorBlock>
            ) : null}
        </PasswordBlock>
        <ConfirmPasswordBlock>
            <InputElementTitle>비밀번호 확인</InputElementTitle>
            <PasswordInputBlock>
                <InputStyle type='password' className={confirmPasswordErrorClassName} onChange={handleChangeConfirmPassword} value={confirmPassword} placeholder='다시한번 비밀번호를 입력해 주세요' />
                {confirmPassword.length >= 2 ? (
                    <DeleteButton onClick={() => setConfirmPassword('')}>
                    <DeleteIcon src={cancelIcon} />
                </DeleteButton>
                ) : null}
            </PasswordInputBlock>
            {confirmPasswordError ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon}/>
                    <ErrorMessage>{confirmPasswordError}</ErrorMessage>
                </ErrorBlock>
            ) : null}
        </ConfirmPasswordBlock>
    </SignupPasswordSection>
    );
}

export default SignupPasswordScene;